import React from 'react';
import {useIntl} from 'react-intl';

import Typography from 'brandComponents/Typography';

import {IProductMadeToOrderProps} from './IProductMadeToOrder';
import messages from './messages';

const ProductMadeToOrder = ({element, classNames}: IProductMadeToOrderProps) => {
	const intl = useIntl();

	return (
		<Typography variant={element} classNames={classNames}>
			{intl.formatMessage(messages.madeToOrder)}
		</Typography>
	);
};

export default ProductMadeToOrder;
